<template>
<div class="focused-panel">
  <div class="d-flex well-toolbar">
    <!-- <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create well" :pressed.sync="addEnabled" variant="primary">
      <icon scale=".6" name="plus" />
    </b-btn> -->

    <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select well" :pressed.sync="selectEnabled" variant="primary">
      <icon scale=".6" name="hand-pointer" />
    </b-btn>

    <b-btn class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
      <icon scale=".6" name="undo" />
    </b-btn>
    <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
      Undo
    </b-tooltip>


    <!-- <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Move well" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled" variant="primary">
      <icon scale=".6" name="arrows-alt" />
    </b-btn> -->

    <b-btn class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
      <icon scale=".6" name="pencil-alt" />
    </b-btn>

    <b-btn class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete well" :disabled="!wellFeatureSelected" variant="primary">
      <icon scale=".6" name="times" />
    </b-btn>

    <b-btn class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers" variant="primary">
      <icon scale=".6" name="link" />
    </b-btn>

    <!--<b-btn :disabled="!hasChanges" variant="primary" @click="otfCommentShow=true">-->
    <!--<icon :name="saving ? 'spinner' : 'save'" :pulse="saving"/>-->
    <!--</b-btn>-->
  </div>

  <b-modal v-model="showForm" size="lg" no-close-on-backdrop no-close-on-esc>
    <div slot="modal-header">
      <label>{{formTitle}}</label>
      <!-- <div v-if='editablePhase'>
        <div v-if="!featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Lock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
          <span v-if='hoverLock' @click='setLockState(true)'><icon scale=".8" name="lock"/></span>
          <span v-if="!hoverLock"><icon scale=".8" name="unlock"/></span>
        </div>

        <div v-if="featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Unlock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
          <span v-if='hoverLock' @click='setLockState(false)'><icon scale=".8" name="unlock"/></span>
          <span v-if="!hoverLock"><icon scale=".8" name="lock"/></span>
        </div>
      </div> -->
    </div>
    <div class="p-2">
      <div id='feature-locked-warning' v-if="!editablePhase">
        <b-alert class='user-reminder' variant="warning" show>This feature is locked. It cannot be edited in this Area of responsibility</b-alert>
      </div>
      <!-- <div id='feature-locked-warning' v-if="editablePhase && featureLock">
        <b-alert class='user-reminder' variant="warning" show>This feature is locked. Click the unlock button in the upper right to edit feature</b-alert>
      </div> -->
      <b-form>
        <b-row>
          <b-col>
            <div id='pad-concept-id' v-if="wellFeature && wellFeature.get('concept_id')">
              <b-alert class='user-reminder' variant="info" show>Concept ID: {{wellFeature.get('concept_id')}}</b-alert>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Ident:" label-for="wellIdent">
              <b-form-input :state="identState" id="wellIdent" :disabled="featureLock" v-model="wellAttrs['ident']" required placeholder="Enter well ident"></b-form-input>
              <b-form-invalid-feedback>
                Well ident is not unique, change will be ignored
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="UWI:" label-for="wellUwi">
              <b-form-input id="wellUwi" :disabled="featureLock" v-model="wellAttrs['uwi']" placeholder="Enter UWI"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="ACQ HoleId:" label-for="wellAcq_holeid">
              <b-form-input id="wellAcq_holeid" :disabled="featureLock" v-model="wellAttrs['acq_holeid']" required placeholder="Enter ACQ HoleId"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="ACQ Short HoleId:" label-for="wellAcq_short_holeid">
              <b-form-input id="wellAcq_short_holeid" :disabled="featureLock" v-model="wellAttrs['acq_short_id']" required placeholder="Enter ACQ short HoleId"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Project:" label-for="project">
              <b-form-select id="project" :disabled="featureLock" v-model="wellAttrs['project']" :options="project_options"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Phasing Wave Priority:" label-for="phasing_wave_priority">
              <b-form-input id="phasing_wave_priority" :disabled="featureLock" v-model="phasing_wave_priority" placeholder="Enter Phasing Wave Prio" type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Absolute seq:" label-for="abs_seq">
              <b-form-input id="abs_seq" :disabled="featureLock" v-model="abs_seq" placeholder="Enter absolute sequence" type="number"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Batch override:" label-for="batch_override">
              <b-form-input id="batch_override" :disabled="featureLock" v-model="batch" placeholder="Enter batch override" type="number"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col>
            <b-form-group label="Easting override:" label-for="coord_override_easting">
              <b-form-input id="coord_override_easting" :disabled="featureLock" v-model="coords_easting" placeholder="Enter easting override"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Northing override:" label-for="coord_override_northing">
              <b-form-input id="coord_override_northing" :disabled="featureLock" v-model="coords_northing" placeholder="Enter northing override"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col>
            <b-form-group label="Comment:" label-for="wellComment">
              <b-textarea id="wellComment" :disabled="featureLock" v-model="wellAttrs['comment']" rows="2"></b-textarea>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <div slot="modal-footer" class="designatron-modal-footer">
      <b-row>
        <b-col>
          <div v-if="isToolEnabled('update_from_survey') && !featureLock" id="update-survey-container">
            <b-btn size="sm" @click="surveyUpdate">
              Update from survey
            </b-btn>
          </div>
        </b-col>
        <b-col>
          <div role="group" class="btn-group">
            <b-btn size="sm" class="float-right" variant="primary" @click="close">
              Close
            </b-btn>
            <b-btn size="sm" :disabled="featureLock" class="float-right" variant="success" @click="onOK">
              Save
            </b-btn>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</div>
</template>

<script>
import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'

export default {
  name: 'well-editor',
  components: {},
  mixins: [FeatureEditorMixin],
  data() {
    return {
      wellAttrs: {
        // well_qty: 1,
        ident: '',
        comment: '',
        putondate: null,
        acq_holeid: null,
        acq_short_id: null,
        gas_dest: null,
        uwi: null,
        project: null
      },
      gasDestOptions: [],
      phasing_wave_priority: null,
      batch: null,
      coords_northing: null,
      coords_easting: null,
      abs_seq: null,
      hoverLock: false,
      lockable: true,
      schema: 'well',
      identState: null,
      initialIdent: null,
      noIdentOnInsert: true
    }
  },
  computed: {
    project_options () {
      return this.$store.getters['user/settings'].filter(s => s.usedfor === 'ui' && s.param === 'well_project_options')
        .map(s => s.value)[0].split(', ')
    }
  },
  methods: {
    close(evt) {
      this.wellFeature = null
      this.showForm = false
      this.onCancel()
    },
    surveyUpdate() {
      this.updateFeatureFromSurvey()
      this.close()
    },
    parseOverrides() {
      let overrides
      if (this.wellFeature.get('overrides')) {
        try {
          overrides = JSON.parse(this.wellFeature.get('overrides'))
        } catch (e) {
          console.log("ERROR: could not parse well overrides")
        }
      }

      if (overrides) {
        if (overrides.phasing_wave_priority) {
          this.phasing_wave_priority = overrides.phasing_wave_priority
        } else {
          this.phasing_wave_priority = null
        }

        if (overrides.batch) {
          this.batch = overrides.batch
        } else {
          this.batch = null
        }

        if (overrides.coords) {
          this.coords_northing = overrides.coords['northing']
          this.coords_easting = overrides.coords['easting']
        } else {
          this.coords_northing = null
          this.coords_easting = null
        }

        if (overrides.abs_seq) {
          this.abs_seq = overrides.abs_seq
        } else {
          this.abs_seq = null
        }
      } else {
        this.phasing_wave_priority = null
        this.batch = null
        this.abs_seq = null
        this.coords_northing = null
        this.coords_easting = null
      }
    },
    packOverrides() {
      let overrides = {}
      if (this.wellFeature.get('overrides')) {
        try {
          overrides = JSON.parse(this.wellFeature.get('overrides'))
        } catch (e) {
          console.log("ERROR: could not parse well overrides")
        }
      }
      if (!overrides) {
        overrides = {}
      }
      if (this.phasing_wave_priority && (parseInt(this.phasing_wave_priority) == this.phasing_wave_priority) && (parseInt(this.phasing_wave_priority) > 0)) {
        overrides['phasing_wave_priority'] = parseInt(this.phasing_wave_priority)
      } else {
        overrides['phasing_wave_priority'] = undefined
      }

      if (this.batch && (parseInt(this.batch) == this.batch) && (parseInt(this.batch) > 0)) {
        overrides['batch'] = parseInt(this.batch)
      } else {
        overrides['batch'] = undefined
      }

      if (this.coords_northing && this.coords_northing.length > 0 && this.coords_easting && this.coords_easting.length > 0) {
        overrides['coords'] = {northing: this.coords_northing, easting: this.coords_easting}
      } else {
        overrides['coords'] = undefined
      }

      if (this.abs_seq && (parseInt(this.abs_seq) == this.abs_seq) && (parseInt(this.abs_seq) > 0)) {
        overrides['abs_seq'] = parseInt(this.abs_seq)
      } else {
        overrides['abs_seq'] = undefined
      }
      this.wellAttrs['overrides'] = JSON.stringify(overrides)
    },
    fetchGasDestOptions() {
      this.$http.get('/api/layers/gas-dest-options')
        .then(res => {
          let fil = res.body.filter(f => f.name)
          this.gasDestOptions = fil.map(m => {
            return {
              text: m.name,
              value: m.name
            }
          })
          this.gasDestOptions = this.gasDestOptions.concat({
            text: 'None',
            value: 'None'
          })
        }, res => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not load gas dest options',
            type: 'error'
          })
        })
    },
  },
  watch: {
    otfIssueId(val) {
      if (val) {
        let issue = this.otfIssuesRaw.filter(i => i.id === val)[0]
        this.otfStatusId = issue.status.id
      }
    },
    showForm(val) {
      if (val) {
        this.parseOverrides()
        if (this.gasDestOptions.length === 0) {
          this.fetchGasDestOptions()
        }
      }
    },
    phasing_wave_priority(val) {
      this.packOverrides()
    },
    batch(val) {
      this.packOverrides()
    },
    coords_northing(val) {
      this.packOverrides()
    },
    coords_easting(val) {
      this.packOverrides()
    },
    abs_seq(val) {
      this.packOverrides()
    },
    wellAttrs: {
      handler(val) {
        if (!this.initialIdent) {
          this.initialIdent = val.ident
        }
        else if (this.initialIdent !== val.ident) {
          let me = this
          this.validateIdent(val.ident)
        } else {
          this.identState = null
        }
      },
      deep: true
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/WellEditor.vue